export default "__VITE_ASSET__DDzm$ykm__"